module.exports = __webpack_public_path__ + "static/media/icon_2.ca95817f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/icon_2.svg
// module id = 370
// module chunks = 0